<template>
  <p class="mb-0 text-caption text-muted">{{ appVersion }}</p>
</template>

<script setup lang="ts">
import { appVersion } from "@/utils/appVersion";
</script>
